import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import EmptyState from '@/components/common/EmptyState.jsx';
import { cerrarAlerta, fetchGerencialAlertas } from '@/services/gerencial.js';

export default function GerencialAlertasPage() {
  const navigate = useNavigate();
  const [rows, setRows] = useState([]);
  const [estado, setEstado] = useState('abierta');

  const load = async () => setRows(await fetchGerencialAlertas({ estado }));
  useEffect(() => { load().catch(() => {}); }, [estado]);

  return (
    <div className="mx-auto w-full max-w-[1400px] px-6 py-6 text-[rgb(var(--fg))]">
      <h1 className="text-2xl font-semibold">Gerencial / Alertas</h1>
      <div className="mt-4 flex gap-2">
        <select className="rounded-xl border border-[rgba(var(--border),0.7)] bg-[rgba(var(--panel),0.9)] px-3 py-2" value={estado} onChange={(e) => setEstado(e.target.value)}>
          <option value="abierta">Abiertas</option>
          <option value="cerrada">Cerradas</option>
        </select>
      </div>
      {rows.length === 0 ? <div className="mt-4"><EmptyState title="Sin alertas" description="No hay alertas para el estado seleccionado." /></div> : (
        <div className="mt-4 overflow-auto rounded-2xl border border-[rgba(var(--border),0.6)] bg-[rgba(var(--panel),0.9)] p-3">
          <table className="w-full text-sm"><thead><tr><th>Severidad</th><th>Tipo</th><th>Título</th><th>Fecha</th><th /></tr></thead><tbody>
            {rows.map((row) => (
              <tr key={row.id} className="border-t border-[rgba(var(--border),0.5)]">
                <td>{row.severidad}</td><td>{row.tipo}</td><td>{row.titulo}</td><td>{String(row.createdAt).slice(0, 10)}</td>
                <td className="space-x-2 text-right">
                  <button className="rounded-lg border border-[rgba(var(--border),0.7)] px-2 py-1" onClick={() => navigate('/guias?filtros=' + encodeURIComponent(typeof row.payloadJson === 'string' ? row.payloadJson : JSON.stringify(row.payloadJson || {})))}>Ir al listado</button>
                  <button className="rounded-lg bg-[rgb(var(--brand))] px-2 py-1 text-white" onClick={async () => { await cerrarAlerta(row.id); await load(); }}>Cerrar</button>
                </td>
              </tr>
            ))}
          </tbody></table>
        </div>
      )}
    </div>
  );
}
